import { SUCCESSFUL_GET_MYPAYMENTS } from "./actionConst";

const initialState = {
    items: [],
    item: {}
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SUCCESSFUL_GET_MYPAYMENTS:
            return {
                ...state,
                items: action.payload
            }
        default:
            return state;

    }
}


// WEBPACK FOOTER //
// ./src/reducers/mypayments/mypaymentsReducer.js